import React from "react";
import classes from "../styles/container.module.css";

import Hero from "../components/hero";
import Research from "../components/research";
import Education from "../components/education";
import Publication from "../components/publication";
import Contact from "../components/contact";

const Home = () => {
  return (
    <div className={ classes.container } >
      <Hero />
      <Research />
      <Education />
      <Publication />
      <Contact />
    </div>
  );
}

export default Home;